import axios from 'axios';

// 创建一个 axios 实例
const instance = axios.create({
  baseURL: '/api', // 使用代理路径
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
  }
});

// 封装 GET 请求
export const getRequest = async (url, params = {}) => {
  try {
    const response = await instance.get(url, { params });
    return response.data;
  } catch (error) {
    console.error('GET 请求错误:', error);
    throw error;
  }
};

// 封装 POST 请求
export const postRequest = async (url, data = {}) => {
  try {
    const response = await instance.post(url, data);
    return response.data;
  } catch (error) {
    console.error('POST 请求错误:', error);
    throw error;
  }
};